// ------------------------------------------------------------------------------
// name: constants
// author: mudas
// created: 2024-11-21
// ------------------------------------------------------------------------------

import { ProjectRole } from '../project';

export { ProjectRole as UserTaskRole };

export enum TaskPrivacyPolicy {
  Public = 'PUBLIC',
  InviteOnly = 'INVITE_ONLY',
}

export enum PublishWay {
  Public = 'PUBLIC', // 公开
  Private = 'PRIVATE', // 私有
}

export enum CreditStrategy {
  Range = 'RANGE',
  Constant = 'CONSTANT',
}

export enum TaskStatus {
  AllStatus = 'ALL',
  Bidding = 'BIDDING', // 竞标中，0.7.0合并竞标和任务
  Processing = 'PROCESSING', // 进行中
  Accepted = 'ACCEPTED', // 已验收
  Settling = 'SETTLING', //结算中,
  End = 'END', //已结束
}

export enum StageStatus {
  // AllStatus = 'ALL',
  PendingProcessing = 'PENDING_PROCESSING', // 未开始
  PendingInternalCheck = 'PENDING_INTERNAL_CHECK', // 待审核
  PendingIterate = 'PENDING_ITERATE', // 待修改
  Processing = 'PROCESSING', // 进行中
  Pass = 'PASS', // 已通过
}

// 0.7.0新版工作台，任务状态区分了子任务查询，这个枚举类型作为查询任务列表的stageStatus
export enum SecondaryTaskStatus {
  Processing = 'PROCESSING', // 进行中
  PendingInternalCheck = 'PENDING_INTERNAL_CHECK', // 待审核
  PendingIterate = 'PENDING_ITERATE', // 待修改
  Pass = 'PASS', // 全部阶段已，需要待通过父任务

  End = 'END', // 已结束
  Canceled = 'CANCELED', // 需求方已撤销
  LoseElection = 'LOSE_ELECTION', // 制作方已落选
  Revocation = 'REVOCATION', // 制作方已撤销申请
}

export const ProcessTaskMap = {
  [SecondaryTaskStatus.Processing]: '待提交',
  [SecondaryTaskStatus.PendingInternalCheck]: '待审核',
  [SecondaryTaskStatus.PendingIterate]: '待修改',
  [SecondaryTaskStatus.Pass]: '待通过',
};

export const AllocatorEndTaskMap = {
  [SecondaryTaskStatus.End]: '已结算',
  [SecondaryTaskStatus.Canceled]: '已撤销',
};

export const ExternalEndTaskMap = {
  [SecondaryTaskStatus.End]: '已结算',
  [SecondaryTaskStatus.LoseElection]: '已落选',
  [SecondaryTaskStatus.Revocation]: '已撤销',
};

export enum TaxSettlementFlag {
  TaskAfter061 = 0, //     新任务,10.14海昕要求修改
  UnsettlementTaskBefore061 = 1, //  老任务未结算
  settlementTaskBefore061 = 2, //老任务已结算
}
// 任务模式
export enum ParentTaskMode {
  Unknown = 0,
  Entrust = 1,
  Platform = 2,
}
